import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

import RadioCheckedIcon from './../assets/RadioChecked.svg';
import RadioUncheckedIcon from './../assets/RadioUnchecked.svg';

export default (theme: APTheme) => createStyles({
  checked: {
    backgroundImage: `url(${RadioCheckedIcon})`,
  },
  icon: {
    backgroundRepeat: 'none',
    backgroundSize: 'contain',
    height: 26,
    width: 26
  },
  referralsSearchRadioIcon: {
    height: 21,
    width: 21
  },
  unchecked: {
    backgroundImage: `url(${RadioUncheckedIcon})`
  }
});
